import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/finance/vendor-payments',
}).lazy(() => import('./vendor-payments.index.lazy').then((d) => d.Route))
